<template>
  <div class="row">
    <InputWithLabel
      class="columns small-12 medium-6"
      :label="$t('APP.RELEASES.CHANGELOGS_FA')"
    >
      <Editor :value="value.changelogFa" dir="rtl" @input="updateChangelogFa" />
    </InputWithLabel>

    <InputWithLabel
      class="columns small-12 medium-6"
      :label="$t('APP.RELEASES.CHANGELOGS_EN')"
    >
      <Editor
        :value="value.changelogEn"
        dir="ltr"
        class="text-latin"
        @input="updateChangelogEn"
      />
    </InputWithLabel>
  </div>
</template>

<script>
import InputWithLabel from '@@/common/InputWithLabel';
import Editor from '@@/common/Editor';

export default {
  name: 'NewReleaseChangelogs',
  components: { InputWithLabel, Editor },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateChangelogEn(changelogEn) {
      this.emitInputEvent({ changelogEn });
    },
    updateChangelogFa(changelogFa) {
      this.emitInputEvent({ changelogFa });
    },
    emitInputEvent(updatedValue) {
      this.$emit('input', {
        ...this.value,
        ...updatedValue,
      });
    },
  },
};
</script>
